/* eslint-disable no-console */
import {OldPermissionDataType, NewPermissionDataType} from './addRoleInterface';

const transformPermissions = (
  oldPermissions: OldPermissionDataType[]
): NewPermissionDataType[] => {
  const newPermissionsMap: Record<string, NewPermissionDataType> = {};
  const newPermissions: NewPermissionDataType[] = [];

  const subTabLabels: Record<string, boolean> = {};

  oldPermissions.forEach((oldPermission) => {
    if (!oldPermission.parentPermission) {
      newPermissionsMap[oldPermission._id] = {
        key: oldPermission._id,
        title: oldPermission.title,
        all: oldPermission.order === 1,
        subTab: [],
        order: oldPermission.order
      };
    }
  });

  oldPermissions.forEach((oldPermission) => {
    if (oldPermission.parentPermission) {
      const mainArray = newPermissionsMap[oldPermission.parentPermission];
      if (mainArray) {
        const subTabKey = oldPermission.parentPermission;
        const subTabLabel = oldPermission.title;

        if (!subTabLabels[subTabLabel]) {
          subTabLabels[subTabLabel] = true;
          const allOptions = [
            {
              key: oldPermission._id,
              title: oldPermission.title,
              type: oldPermission.type,
              checked: mainArray.order === 1,
              order: oldPermission.order
            }
          ];
          mainArray.subTab.push({
            subTabKey,
            subTabLabel,
            allOptions
          });
        } else {
          mainArray.subTab.forEach((subTab: any) => {
            if (subTab.subTabLabel === subTabLabel) {
              subTab.allOptions.push({
                key: oldPermission._id,
                title: oldPermission.title,
                type: oldPermission.type,
                checked: mainArray.order === 1,
                order: oldPermission.order
              });
            }
          });
        }
      }
    }
  });

  for (const key in newPermissionsMap) {
    if (Object.prototype.hasOwnProperty.call(newPermissionsMap, key)) {
      const permission = newPermissionsMap[key];
      if (permission.subTab.length === 0) {
        const parentPermission = oldPermissions.find(
          (permission) => permission._id === key
        );
        if (parentPermission) {
          const subTabKey = parentPermission._id;
          const subTabLabel = parentPermission.title;
          const allOptions = [
            {
              key: parentPermission._id,
              title: parentPermission.title,
              type: parentPermission.type
            }
          ];
          permission.subTab.push({
            subTabKey,
            subTabLabel,
            // checkAllOptions: permission.order === 1,
            allOptions
          });
        }
      }
      newPermissions.push(permission);
    }
  }

  return newPermissions.sort((a, b) => {
    return a?.order - b?.order;
  });
};

export default transformPermissions;
